import { Box, Stack } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { Common, Custom, Page, Workflow } from "components";
import { Utils, useFlow } from "components/workflow";
import {
  createDefaultFeedback,
  createDefaultSettings,
  createDefaultUser,
} from "interfaces";
import { useApp, useService, useSession, useTheme } from "contexts";
import { ChevronLeftRounded } from "@mui/icons-material";
import { Enums, Routes } from "utils";
import { MessageType, SessionType } from "types";

const Onboarding = () => {
  const { theme } = useTheme();
  const { login } = useSession();
  const { setFeedback, t } = useApp();
  const { emailService } = useService();

  const onSubmit = async (
    name: string,
    data: Workflow.Utils.OnboardingType
  ) => {
    const { user } = data;

    if (user) {
      // login({
      //   id: user._id,
      //   name: user.full_name,
      //   email: user.email,
      //   role: user.role,
      //   settings: createDefaultSettings(),
      // } as SessionType);

      // send email
      // emailService.newUser(
      //   user.email,
      //   t.message.subject.sign_up,
      //   user._id,
      //   user.full_name,
      //   user.role
      // );

      return setFeedback({
        message: t.message.feedback.request_create_success,
        severity: Enums.EnumFeedback.Success,
      } as MessageType);
    } else {
      return setFeedback({
        message: t.message.feedback.request_error,
        severity: Enums.EnumFeedback.Error,
      } as MessageType);
    }
  };

  const {
    current,
    data,
    direction,
    getVariants,
    handlePrev,
    handleSubmit,
    step,
    StepComponent,
    stepRef,
    steps,
    updateData,
  } = useFlow<Workflow.Utils.OnboardingType>(
    {
      name: Enums.EnumFlow.Onboarding,
      count: Utils.OnboardingSteps.length,
      step: 1,
      end: Utils.OnboardingSteps.length - 1,
      route: Routes.home,
    },
    onSubmit
  );

  if (!current) return <Page.Loader />;

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        border: 1,
        overflow: "hidden",
        mt: theme.spacing.md,
        px: theme.spacing.lg,
        pt: theme.spacing.lg,
        pb: theme.spacing.xxl,
        borderRadius: theme.border.radius,
        borderColor: theme.color.primary.accent,
      }}
    >
      <AnimatePresence mode="wait">
        <Box
          component={motion.div}
          key={step}
          variants={getVariants(direction)}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.4 }}
        >
          <StepComponent.Component
            ref={stepRef}
            data={data}
            updateData={updateData}
          />
        </Box>
      </AnimatePresence>

      <Box mt={theme.spacing.sm}>
        <Common.Divider sx={{ backgroundColor: theme.color.border.accent }} />
        <Stack direction="row" spacing={theme.spacing.xs}>
          {step !== steps && (
            <>
              <Custom.Button onClick={handlePrev} secondary>
                <ChevronLeftRounded />
              </Custom.Button>
              <Custom.Button
                submit
                fullWidth
                trailing="right"
                variant="contained"
              >
                {t.action.next}
              </Custom.Button>
            </>
          )}
          {step === steps && (
            <Custom.Button
              submit
              fullWidth
              trailing="right"
              variant="contained"
            >
              {t.action.finish}
            </Custom.Button>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export const Wrapper = () => {
  return (
    <Workflow.Wrapper
      initData={{
        user: createDefaultUser(),
        feedback: createDefaultFeedback(),
      }}
    >
      <Onboarding />
    </Workflow.Wrapper>
  );
};
